import { ObserverService, ContentService, LessonService, PortfolioService } from "@DavisDigital/davisdigitalfrontend.module";
import { AccessAccount, FolderTypes} from "@DavisDigital/interfaces";

export type ContentType = 'portfolio' | 'folder' | 'lesson';

class MoveContentModalController {
    
    private close:Function; //injected from modal-service
    
    public showNewFolder:boolean = false;
	public newFolderName:string;
	public addingFolder:boolean;
    public loading:boolean = false;
    
    public title: string;
    public baseObjectId: string;
    public folders:any;
    public folderID:string = "";
	public type:ContentType;
    public folderType: string;

	// @ngInject
	constructor(
		public contentService   : ContentService, 
		public lessonService	: LessonService,
		public portfolioService	: PortfolioService
	){}
	
	public $onInit = () => {
        if(this.type=="lesson") {
        	if(this.folderType=='ftSharedLesson') {
        		this.getSharedLessonFolders();
        	} else {
        	  this.getLessonFolders();
        	}
		} else if(this.type == 'portfolio') {
			this.getPortfolioFolders();
		}
	}
	
	public onCloseModal = () =>{
		this.close();
	}
	
	public selectFolder = ( folder ) => {
		this.folderID = folder.folderID;
	}
	
	public moveLesson = () => {
		
		if( this.loading ) {
			return;
		}
		
		this.loading = true;
		if( this.folderID != "") {
			if(this.type=="lesson") {
				this.lessonService.moveLesson(this.baseObjectId, this.folderID).then(this.onMoveLessonCallback);
			} else if(this.type=='portfolio') {
				if(this.folderType == FolderTypes.MySharedWithMePortfolio || this.folderType == FolderTypes.MyStudentsPortfolio) {
					this.portfolioService.movePortfolioAsFolderItem(this.baseObjectId, this.folderID).then(this.onMoveLessonCallback);	
				} else {
					this.portfolioService.movePortfolio(this.baseObjectId, this.folderID).then(this.onMoveLessonCallback);
				}
				
			}
		}
	}
	
	public addNewFolder = () => {
		if(this.newFolderName && !this.addingFolder){
			this.addingFolder = true;
		    this.contentService
		    .createFolder( this.newFolderName,this.folderType )
    		.then( result => {
    			if(result?.data){
    				if(result?.successfulActions?.length && result.data){
    					this.folders.push(result.data);
    				}
    				this.showNewFolder = false;
    				this.addingFolder = false;
    			}
    		})
    		//TODO: handle errros
    		.catch(console.error);
		}
	}
	
	private onMoveLessonCallback = (result) => {
		this.loading = false;
		if( result.successfulActions.length ) {
			this.onCloseModal();
		}
	}
	
	private getLessonFolders = () => {
		let data = { 
			showAll: true,
			folderType: this.folderType,
			ignoreArchiveFolder: true,
		}
		
		this.lessonService.getMyLessonFolders( data ).then( result => {
			this.folders = result.data.records;
		});
	}
	
	private getPortfolioFolders = () => {
		let data = { 
			showAll: true,
			folderType: this.folderType,
			bustCache: true,
			ignoreArchiveFolder: true,
		}
		
		this.portfolioService.getMyPortfolioFolders( data ).then( result => {
			this.folders = result.data.records;
		});
	}
	
	private getSharedLessonFolders = () => {
		let data = { 
			showAll: true,
			folderType: this.folderType,
			ignoreArchiveFolder: true,
		}
		
		this.lessonService.getSharedLessonFolders( data ).then( result => {
			this.folders = result.records;
		});
	}

}
    

class MoveContentModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    title: "<",
	    baseObjectId: "<",
	    type: "<",
	    folderType: "<",
		close:'='
	};

	public controller = MoveContentModalController;
	public controllerAs = 'moveContentModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/move-content-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { MoveContentModal };
